import { useEffect, useState } from 'react';
import JetpackSlideshow from './JetpackSlideshow';
import { Box } from '@mui/material';

export default function WpBlogTest() {
  const [post, setPost] = useState(null);

  useEffect(() => {
    fetch('https://public-api.wordpress.com/wp/v2/sites/mudrostdotblog.wordpress.com/posts')
      .then((res) => res.json())
      .then((data) => {
        setPost(data[0]);
      });
  }, []);

  if (!post) return <p>Loading...</p>;

  const html = post.content.rendered;

  const slideshowMatch = html.match(/<div class="wp-block-jetpack-slideshow[\s\S]*?<\/div><\/div>/);

  const cleanedHTML = html.replace(/<div class="wp-block-jetpack-slideshow[\s\S]*?<\/div><\/div>/, '');

  return (
    <Box sx={{ p: { sm: '0 40px', xs: '0 40px' } }} style={{ margin: '40px auto' }}>
      <h1 dangerouslySetInnerHTML={{ __html: post.title.rendered }} />

      <Box className='wp-content' dangerouslySetInnerHTML={{ __html: cleanedHTML }} />

      {slideshowMatch && <JetpackSlideshow html={slideshowMatch[0]} />}
    </Box>
  );
}
